module.exports = __webpack_public_path__ + "static/media/isner.04774463.jpg";